import { render, staticRenderFns } from "./SupportChildren.vue?vue&type=template&id=f1bd9c94&scoped=true&"
import script from "./SupportChildren.vue?vue&type=script&lang=ts&"
export * from "./SupportChildren.vue?vue&type=script&lang=ts&"
import style0 from "./SupportChildren.vue?vue&type=style&index=0&id=f1bd9c94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bd9c94",
  null
  
)

/* custom blocks */
import block0 from "./SupportChildren.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports